import {
  ICheckbox,
  IColorPicker,
  IDatePicker,
  IFile,
  IFormDocument,
  IInput,
  IOTP,
  IPassword,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { TypedControlBase } from '../typed-controls';

export interface CheckboxControlWithValue extends TypedControlBase {
  readonly control: ICheckbox;
  readonly type: 'checkbox';
  value: string;
}

/**
 * Check that input control meta is checkbox meta
 *
 * @param control - control metadata
 */
export function isCheckboxControl(
  control:
    | ICheckbox
    | IColorPicker
    | IDatePicker
    | IFile
    | IInput
    | IOTP
    | IPassword,
): control is ICheckbox {
  return control.$type === 'checkbox' || control.$type === 'toggle';
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param control - control metadata
 * @param doc - doc
 */
export function getTypeControlForCheckbox(
  control: ICheckbox,
  doc: IFormDocument,
): CheckboxControlWithValue {
  return {
    value:
      // @HACK there is no caring of what value comes from BE when control is mixed, BUT - ispui-checkbox, that is used for checkbox displaying
      // must have 'on' value for displaying mixed value. So pretend, that mixed value is initially 'on'
      control.$mixed === 'yes'
        ? 'on'
        : DocHelper.getStringValue(control.$name, doc),
    control,
    type: 'checkbox',
  } as CheckboxControlWithValue;
}
